function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zM4.77 17h4.28c-.03.16-.05.33-.05.5V19H2v-1.5C2 15.17 6.66 14 9 14c.56 0 1.25.07 1.98.2-.71.48-1.3 1.08-1.64 1.81-.055 0-.113-.003-.17-.005C9.113 16.003 9.055 16 9 16c-1.53 0-3.24.5-4.23 1zm11.73-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm2.5-4c0 .94-.53 1.75-1.29 2.18-.36.2-.77.32-1.21.32-.44 0-.85-.12-1.21-.32A2.511 2.511 0 0114 10.5a2.5 2.5 0 015 0z",
  fill: "#8C8C8C"
});

function SvgIconHomeUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgIconHomeUsers;